import {Theme, useTheme} from "@mui/material/styles";
import Box from "../Common/Box";
import RoundButton from "../Common/RoundButton";
import Close from "@mui/icons-material/Close";
import React, {ReactNode} from "react";
import {User as UserClass} from "../lib/stores/UserStore";
import User from "./User";

interface SublistUserProps {
    onRemove: () => void
    onRemoveText: string
    user: UserClass
    children?: ReactNode
}

export function SublistUser({children, onRemove, onRemoveText, user}: SublistUserProps) {

    const theme = useTheme();

    return <Box
            sx={{
                //@todo check if this should be undefined.. used to be non-existent primaryBackground prop
                bgcolor: (theme: Theme) => theme.palette.background.default,
                borderBottom: (theme: Theme) => theme.palette.mode === "dark" ? "1px solid  #1f1f1f" : "1px solid #bfbfbf",
            }}
            row center padding={"10px"}
    >
        <User
                sx={{padding: 0, flex: 1}}
                user={user}
                owner={false}
                mini
        />
        <Box padding={"4px"} row center>
            {children}
            <RoundButton
                    width={24}
                    icon={Close}
                    label={onRemoveText}
                    hoverColor={theme.palette.mode === "dark" ? "" : "#e5e5e5"}
                    onClick={onRemove}
            />
        </Box>
    </Box>;
}
